import { createSlice, createAsyncThunk, isRejectedWithValue } from '@reduxjs/toolkit'
import axios from 'axios'
import { api } from '../../app/services/api';
import { BACKEND_URL as backendURL } from '../../app/config';

// initialize access token from localstorage
const userToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : null;
const refreshToken = localStorage.getItem('refreshToken') ? localStorage.getItem('refreshToken') : null;
// console.log(refreshToken)

const initialState = {
    loading: false,
    userInfo: null, // for user object
    userToken: null, // for storing the JWT
    refreshToken: null, // for refreshing JWT
    isAuthenticated : false,
    error: null,
    success: false, // for monitoring the registration process.
}

// lifecycle action types
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state) => {
            localStorage.removeItem('accessToken') // deletes token from storage
            localStorage.removeItem('refreshToken') // deletes token from storage
            state.refreshToken = null;
            state.userInfo = null;
            state.isAuthenticated = false;
            state.loading = false;
            state.userInfo = null;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        // register user
        builder.addCase(registerUser.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(registerUser.fulfilled, (state, action) => {
            state.loading = false;
            state.success = true; // registration successful
        });
        builder.addCase(registerUser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Login User
        builder.addCase(userLogin.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.isAuthenticated = false

        });
        builder.addCase(userLogin.fulfilled, (state, action) => {
            state.loading = false;
            state.userInfo = action.payload
            state.isAuthenticated = true
            state.userToken = action.payload.access
            state.userToken = action.payload.refresh
            // state.success = true; // registration successful
        });
        builder.addCase(userLogin.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.isAuthenticated = false
        });

        // Get Current User Info
        builder.addCase(getCurrentUser.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.isAuthenticated = false

        });
        builder.addCase(getCurrentUser.fulfilled, (state, action) => {
            state.loading = false;
            state.userInfo = action.payload
            state.isAuthenticated = true
            state.userToken = action.payload.access
            state.userToken = action.payload.refresh
            // state.success = true; // registration successful
        });
        builder.addCase(getCurrentUser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.isAuthenticated = false
        });

        // Get Current User Info After Changing Name
        builder.addCase(getUserAfterNameChange.pending, (state) => {
            state.loading = true; // Just turn on a loading spinner if you want

        });
        builder.addCase(getUserAfterNameChange.fulfilled, (state, action) => {
            state.loading = false;
            state.userInfo = action.payload // Just update the user data!
        });
    },
})

// ACTIONS

// configure header's content-type as json
const config = {
    headers: {
        'Content-Type' :  'application/json',
        // 'Authorization', `Bearer ${userToken}`
        },
    }

// Register User Action
export const registerUser = createAsyncThunk(
    'auth/register',
    async ({username, email, password, confirmation }, { rejectWithValue }) => {
        try{
            const re = await axios.post(
                `${backendURL}/api/register/`,
                { username, email, password, confirmation },
                config
            )
            console.log(re.data) // print response data, usually message
        } catch (error) {
            // returt custom error message from backend if present
            if(error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)

// Login User Action
export const userLogin = createAsyncThunk(
    'auth/login',
    async ({ username, password }, { rejectWithValue }) => {
        try{
            const { data } = await axios.post(
                `${backendURL}/api/login/`,
                { username, password },
                config
            )
            // store user's token in local storage
            localStorage.setItem('accessToken', data.access)
            localStorage.setItem('refreshToken', data.refresh)
            return data
            
        }
        catch (error) {
            // return custom error message from API if any
            if (error.response && error.response.data.error) {
                return rejectWithValue(error.response.data.error)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)
// Get Current user
export const getCurrentUser = createAsyncThunk(
    'auth/user',
    async (_, { rejectWithValue }) => {
        try{
            const { data } = await api.get("/user/")
            
            // store user's token in local storage
            //localStorage.setItem('accessToken', data.access)
            //  console.log(data)
            return data
            
        }
        catch (error) {
            // return custom error message from API if any
            if (error.response && error.response.data.error) {
                return rejectWithValue(error.response.data.error)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)

// Get Current user name after name change
export const getUserAfterNameChange = createAsyncThunk(
    'auth/username',
    async (_, { rejectWithValue }) => {
        try{
            const { data } = await api.get("/user/")
            
            // store user's token in local storage
            //localStorage.setItem('accessToken', data.access)
            //  console.log(data)
            return data
            
        }
        catch (error) {
            // return custom error message from API if any
            if (error.response && error.response.data.error) {
                return rejectWithValue(error.response.data.error)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
)

/* // Get Current user
export const getCurrentUser = createAsyncThunk(
    'auth/user',
    async (_, { rejectWithValue }) => {
        try{
            const { data } = await axios.get(
                `${backendURL}/api/user/`,
            )
            // store user's token in local storage
            //localStorage.setItem('accessToken', data.access)
            console.log(data)
            return data
            
        }
        catch (error) {
            // return custom error message from API if any
            if (error.response && error.response.data.error) {
                return rejectWithValue(error.response.data.error)
            } else {
                return rejectWithValue(error.message)
            }
        }
    }
) */
// Export Actions
export const { logout } = authSlice.actions;
export default authSlice.reducer